import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Namespace } from '../../enums';
import { determinePluralFromNumber, Permalink } from '../../helpers';
import { useTheatreRow } from '../../hooks';
import { Theatre } from '../../typings/api';
import styles from './index.module.scss';

interface Props {
  favoriteTheatres: Theatre[];
}

const FavoriteTheatres = ({ favoriteTheatres }: Props): JSX.Element => {
  const { t } = useTranslation(Namespace.Theaters);
  const ref = useRef(null);

  const [showSkeleton, setShowSkeleton] = useState(true);

  useEffect(() => {
    const onLoad = () => {
      setShowSkeleton(false);
    };

    const url = favoriteTheatres[0]?.poster_url;
    if (url) {
      const img = new Image();
      img.onload = onLoad;
      img.onerror = onLoad;
      img.src = url;
    } else {
      onLoad();
    }
  }, [favoriteTheatres, setShowSkeleton]);

  useTheatreRow(ref, showSkeleton);

  const arr = Array.from({ length: 10 }, (v, i) => i);

  return (
    <div className={[styles.favoriteTheatres].join(' ')}>
      <h2>{t('popular_this_week_theatres')}</h2>
      {showSkeleton ? (
        <SkeletonTheme baseColor="#22222E" highlightColor="rgba(72, 72, 72, 0.48)">
          <ul className={styles.skeleton}>
            {arr.map((_, i) => (
              <li key={i}>
                <span className={styles.number}>
                  {/* <Skeleton style={{ height: '100%', width: '100%', borderRadius: 48 }} duration={2}> */}
                  {i + 1}
                  {/* </Skeleton> */}
                </span>
                <div className={styles.circle}>
                  <Skeleton style={{ height: '100%', width: '100%', borderRadius: 48 }} duration={2} />
                </div>
                <div className={styles.rows}>
                  <div className={styles.firstRow}>
                    <Skeleton style={{ height: '100%', width: '100%', borderRadius: 3 }} duration={2} />
                  </div>
                  <div className={styles.secondRow}>
                    <Skeleton style={{ height: '100%', width: '100%', borderRadius: 3 }} duration={2} />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </SkeletonTheme>
      ) : (
        <div ref={ref} className="scroll-wrapper-theatre">
          <ul className={['play-list', 'swiper-wrapper', styles.favorites].join(' ')}>
            {favoriteTheatres?.map((pop, i) => (
              <li key={i} className="swiper-slide">
                <Link href={Permalink.theatre(pop)}>
                  <a>
                    <span className={styles.order}>{i + 1}</span>
                    <span style={{ background: `url(${pop.poster_url})` }} className={styles.favLogo} />
                    <div className={styles.favWrapper}>
                      <h4>{pop.name}</h4>
                      <p>
                        {t(`plays_count_${determinePluralFromNumber(pop?.plays_count)}`, { count: pop?.plays_count })}
                      </p>
                    </div>
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FavoriteTheatres;
